<template>
  <div class="selected-item-list d-flex flex-column">
    <div class="header">
      <h4 class="count">เลือกแล้ว {{ count }} รายการ</h4>
      <sc-button
        v-if="showRemoveAllButton && !deletedAt"
        :disabled="disabledRemoveButton"
        class="remove-all-button"
        @click="handleClickRemoveAllButton"
        >ลบทั้งหมด</sc-button
      >
    </div>
    <div class="list-body">
      <div v-if="isEmpty" class="empty">ไม่มีรายการที่เลือก</div>
      <item-selector-option
        v-for="item in value"
        :key="item.id"
        v-bind="item"
        :can-remove="canRemove && !deletedAt"
        class="selected-item"
        @remove="handleRemoveSelectItem(item.id)"
      ></item-selector-option>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton"
import ItemSelectorOption from "./ItemSelectorOption"

export default {
  components: {
    ItemSelectorOption,
    ScButton,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
    disabled: {
      type: null,
      default: undefined,
    },
    deletedAt: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    isEmpty() {
      return this.value.length === 0
    },
    count() {
      return this.value.length
    },
    disabledRemoveButton() {
      return this.isEmpty || !this.canRemove
    },
    canRemove() {
      return !this.disabled
    },
    showRemoveAllButton() {
      return this.canRemove
    },
  },
  methods: {
    handleRemoveSelectItem(itemId) {
      this.$emit("remove", itemId)
    },
    handleClickRemoveAllButton() {
      this.$emit("removeAll")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.selected-item-list {
  border: $border;
  border-top: 0;
  overflow: auto;
}

.header {
  display: grid;
  grid-template-columns: 1fr auto;

  border-bottom: $border;

  > .remove-all-button {
    height: 43px;
    font-size: 0.8rem;
    color: #444;
    border: 0;
    border-radius: 0;
    border-top-right-radius: $border-radius;
    border-left: $border;

    &:hover,
    &:focus {
      border-color: #dcdfe6 !important;
    }
  }
}

.selected-item-list > .list-body {
  overflow-y: auto;
  max-height: 100%;
}

.empty {
  padding: 20px 0;
  text-align: center;
}

.count {
  margin: 0;
  padding: 10px ($space / 2);

  color: $primary-color;
  font-size: 1.1rem;
  font-weight: bold;
}
</style>
